import { asyncRouterMap, constantRouterMap, systemPage } from '../../router/router'

// import { itemList } from '@/api/master-data-manage'
// import { lazyLoadView } from '@/utils/lazyLoadView'

// function getRawType (value) {
//   return Object.prototype.toString.call(value).slice(8, -1)
// }
/**
 * 通过meta.permission判断是否与当前用户权限匹配
 * @param permissions
 * @param route
 */
function hasPermission (permissionsItem, routes) {
  const filterArr = routes.filter((item) => {
    return item.meta && item.meta.permissions && (item.meta.permissions.includes(permissionsItem.id) || item.meta.permissions.includes('ALL'))
  })
  if (filterArr.length > 0) {
    permissionsItem.meta = filterArr[0].meta
    permissionsItem.meta.title = permissionsItem.name
  }
  return filterArr
}
function hasHiddenRouter (routes) {
  const filterArr = routes.filter((item) => {
    return item.hidden
  })

  return filterArr
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes
 * @param permissions
 */
function filterAsyncRouter (routes, permissions) {
  const filterRouter = []
  permissions.forEach((permissionsItem) => {
    const isPermissionRouter = hasPermission(permissionsItem, routes)
    if (isPermissionRouter) {
      filterRouter.push(...isPermissionRouter)
      if (permissionsItem.childList) {
        filterRouter.push(...filterAsyncRouter(routes, permissionsItem.childList))
      }
    }
  })
  return filterRouter
}

const permission = {
  state: {
    routers: constantRouterMap, // 最终生成的所有routes
    redirectRouter: '',
    addRouters: [] // 动态生成的routes
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    DEL_ROUTERS: (state) => {
      state.addRouters = []
      state.routers = constantRouterMap
      sessionStorage.removeItem('routerPermissions')
    }
  },
  actions: {
    GenerateRoutes ({ commit }, permissions) {
      return new Promise(resolve => {
        let permissionRoutesChildren = asyncRouterMap
        const hiddenRouter = hasHiddenRouter(permissionRoutesChildren)
        permissionRoutesChildren = filterAsyncRouter(permissionRoutesChildren, permissions)
        permissionRoutesChildren.push(...hiddenRouter)
        const publicRouter = systemPage.concat(permissionRoutesChildren)
        sessionStorage.setItem('routerPermissions', JSON.stringify(permissionRoutesChildren))
        commit('SET_ROUTERS', publicRouter)
        resolve()
      })
    }
  },
  getters: {
    redirectRouter (state) {
      return state.redirectRouter
    },
    addRouters (state) {
      return state.addRouters
    }
  }
}

export default permission
